import { createFileRoute, Link } from "@tanstack/react-router";

import { ETAPAS, MODELOS } from "@/lib/campanhas/modelos";

export const Route = createFileRoute("/admin/campanhas-modelo")({
  head: () => ({
    meta: [
      { title: "Modelo de ações · Admin FEO" },
      { name: "description", content: "Roteiro e checklists padrão para lançar, acompanhar e encerrar ações." },
      { property: "og:title", content: "Modelo de ações · Admin FEO" },
      { property: "og:description", content: "Roteiro e checklists padrão das ações da FEO." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ModeloPage,
});

function ModeloPage() {
  return (
    <div className="min-h-screen bg-[#0A0F2C] px-4 py-8 text-white">
      <div className="mx-auto max-w-5xl">
        <Link to="/admin/campanhas" className="text-sm text-white/60 hover:text-white">
          ← Ações de venda
        </Link>
        <h1 className="mt-2 text-2xl font-bold sm:text-3xl">Modelo de ações</h1>
        <p className="mt-1 text-sm text-white/60">
          Roteiro padrão para lançar, acompanhar e encerrar qualquer ação. Use o tipo mais próximo e adapte.
        </p>

        <div className="mt-6 grid gap-3 md:grid-cols-5">
          {ETAPAS.map((e) => (
            <div key={e.titulo} className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
              <p className="text-sm font-bold text-[#F5C518]">{e.titulo}</p>
              <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-white/75">
                {e.itens.map((i) => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <h2 className="mt-10 text-lg font-bold">Checklists por tipo de ação</h2>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          {MODELOS.map((m) => (
            <section key={m.tipo} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
              <h3 className="font-bold">{m.nome}</h3>
              <p className="text-xs text-white/55">
                {m.descricao} Ex.: {m.exemplos}
              </p>
              <p className="mt-3 text-[11px] font-bold uppercase tracking-widest text-emerald-400/80">Início</p>
              <ul className="mt-1 list-disc space-y-1 pl-5 text-sm text-white/80">
                {m.inicio.map((i) => (
                  <li key={i.key}>{i.label}</li>
                ))}
              </ul>
              <p className="mt-3 text-[11px] font-bold uppercase tracking-widest text-[#F5C518]">Encerramento</p>
              <ul className="mt-1 list-disc space-y-1 pl-5 text-sm text-white/80">
                {m.fim.map((i) => (
                  <li key={i.key}>{i.label}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
